module.exports = __webpack_public_path__ + "static/out-of-maos-shadow-7e29d63e8e157182b08b11e158d032c1.jpg";